<template lang="pug">
  .container
    .login(v-if="! isLoggedIn")
      .btn-block(@click="loginWith('google')") Login with Google
      //- .btn-block(@click="loginWith('facebook')") Login with Facebook

    .logout(v-if="isLoggedIn")
      .text-center
        img.rounded-full.mx-auto(:src="user.avatar")
        h2.text-lg.mb-4 {{ user.name }}
        a.btn(href="#" @click="logout()") Logout

</template>

<script>

// import { Form, Input, Icon, Button } from 'ant-design-vue'

export default {
  name: 'Login',
  data: () => ({
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    }
  },
  methods: {
    loginWith (service) {
      this.$router.push({ path: `/login/${service}` })
    },
    logout () {
      this.$store.dispatch('logout')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

.title {
  font-family: 'Quicksand', 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  display: block;
  font-weight: 300;
  font-size: 100px;
  letter-spacing: 1px;

.subtitle {
  font-weight: 300;
  font-size: 42px;
  word-spacing: 5px;
  padding-bottom: 15px;

.links {
  padding-top: 15px;


}
}
}
}</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue